import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import FileProviderConstants from './fileProviderConstants';

export default function convertToAttachmentDataProviderType(
    providerType: string
): AttachmentDataProviderType | null {
    switch (providerType ? providerType.toLowerCase() : null) {
        case FileProviderConstants.ONE_DRIVE_PRO.toLowerCase():
            return AttachmentDataProviderType.OneDrivePro;
        case FileProviderConstants.GDRIVE.toLowerCase():
            return AttachmentDataProviderType.GDrive;
        case FileProviderConstants.ONE_DRIVE_CONSUMER.toLowerCase():
            return AttachmentDataProviderType.OneDriveConsumer;
        case FileProviderConstants.DROPBOX.toLowerCase():
            return AttachmentDataProviderType.Dropbox;
        case FileProviderConstants.BOX.toLowerCase():
            return AttachmentDataProviderType.Box;
        case FileProviderConstants.WOPI_BOX.toLowerCase():
            return AttachmentDataProviderType.WopiBox;
        case FileProviderConstants.WOPI_EGNYTE.toLowerCase():
            return AttachmentDataProviderType.WopiEgnyte;
        case FileProviderConstants.MAILBOX.toLowerCase():
            return AttachmentDataProviderType.Mailbox;
        case FileProviderConstants.FACEBOOK.toLowerCase():
            return AttachmentDataProviderType.Facebook;
        default:
            return null;
    }
}
